// Image helpers shared by both Brand SKU Mapper review views (MFR->DP and v2).

export function uniqueImageUrls(urls) {
  return [...new Set((urls || []).filter(Boolean))];
}

export function countImages(thumbnailUrl, imageUrls) {
  return uniqueImageUrls([thumbnailUrl, ...(imageUrls || [])]).length;
}
